﻿export class ViewRequested {
    static eventName() { return 'ViewRequested'; }

    eventName = ViewRequested.eventName;

    constructor(public viewName: string, public callback: (string) => void) { }
}